/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  CommunicationAttachmentDto,
  CommunicationListItemDto,
  ActivityDetails,
  CommunicationType,
  ContactType,
} from '@gh/builder-shared-data';
import { FileListItem } from '@gh/common-internal-shared';
import { AutocompleteItem, EntityVersion, ID } from '@gh/common-shared-data';
import { addMinutes, cast, getUTCCurrent } from '@gh/core-util';
import { map, omit } from 'lodash';
import { LeadCommunity } from '../../../builder-sales/leads';

export type CommunicationListItem = CommunicationListItemDto;

export type SmsItem = CommunicationListItemDto;
export type WebsiteItem = CommunicationListItemDto;

export type EmailItem = CommunicationListItemDto;
export type EmailAttachment = CommunicationAttachmentDto;

export enum CommunicationEntryPoint { Lead, LeadList, LeadCommunication, LeadBord, Contact, Job }
export type LeadContactDetails = {
  contactId: ID;
  name: string;
  address: string;
  phone: string;
  email: string;
  community: LeadCommunity;
  referredBy: any;
  details: string;
  version: EntityVersion;
};

export type EmailDetails = {
  jobId?: string;
  template?: AutocompleteItem;
  contactId?: ID;
  communicationType: CommunicationType;
  message: string;
  created?: Date;
  files?: FileListItem[];
  communicationId?: ID;
  email?: string;
  emailCc?: string;
  emailBcc?: string;
  subject?: string;
  cellPhone?: string;
  contactTypeCode?: ContactType;
};

export type CommunicationTarget = {
  salesFolderId?: ID;
  jobId?: ID;
  contactId?: ID;
};

export const meetingToCommunicationItem = (predefined: Partial<CommunicationListItem>,
                                           meeting: ActivityDetails): CommunicationListItem => ({
  ...<CommunicationListItem>predefined,
  location: meeting.location,
  created: meeting.addedDate,
  communicationId: meeting.id || meeting.communicationId,
});

export const communicationAttachmentToFile = (attachment: CommunicationAttachmentDto): FileListItem => ({
  id: attachment.googleFileId,
  name: attachment.googleFileName,
  type: attachment.mimeType,
  url: attachment.webViewLink,
  ownerId: attachment.ownerId,
});

export const communicationAttachmentFromFile = (file: FileListItem): CommunicationAttachmentDto => ({
  googleFileId: file.id,
  googleFileName: file.name,
  mimeType: file.type,
  webViewLink: file.url,
  ownerId: file.ownerId,
});

export const emailDetailsFromCommunicationItem = (email: EmailItem): EmailDetails => ({
  ...cast<EmailDetails>(omit(email, ['attachments'])),
  files: map(email.attachments, communicationAttachmentToFile),
});
export const emailDetailsToCommunicationItem = (email: EmailDetails): EmailItem => ({
  ...cast<EmailItem>(omit(email, ['files'])),
  attachments: map(email.files, communicationAttachmentFromFile),
});

export const getEmptyMeeting = (): ActivityDetails => {
  // tslint:disable-next-line:no-magic-numbers
  const dateUTC = getUTCCurrent();
  return {
  allDay: false,
  id: '',
  active: true,
  startDate: dateUTC,
  activityType: '',
  salesFolderId: '',
  // tslint:disable-next-line:no-magic-numbers
  endDate: addMinutes(dateUTC, 30),
  location: '',
  guests: [],
  description: '',
  notes: '',
  isDone: false,
  // @ts-ignore
  assignee: undefined,
  };
};
